import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';
import { Avatar, Box, IconButton } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { ImageInput, useRecordContext } from 'react-admin';

export const AvatarInput = ({
  source = 'avatar',
  sizeMax = 70,
  initialAvatar,
}) => {
  const record = useRecordContext();
  const [featuredImage, setFeaturedImage] = useState(initialAvatar || null);
  const ref = useRef();

  useEffect(() => {
    if (ref.current?.value && !featuredImage) {
      setFeaturedImage(`${ref.current.value}?${Math.random()}`);
    }
  }, [ref]); //eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = () => {
    ref.current.click();
  };

  const onImageChange = e => {
    if (e?.target?.files) {
      setFeaturedImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  return (
    <>
      <Box position="relative" width={'fit-content'}>
        <Avatar
          onClick={handleClick}
          src={
            featuredImage
              ? featuredImage
              : `${
                  record && record[`${source}`]
                    ? record[`${source}`]
                    : '/image.png'
                }?${Math.random()}`
          }
          style={{
            width: sizeMax,
            height: sizeMax,
            cursor: 'pointer',
            marginBottom: 20,
          }}
        />
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{
            position: 'absolute',
            bottom: '-10px',
            right: '-10px',
            borderRadius: '50%',
            color: 'rgb(31, 58, 79)',
            background: 'rgba(255, 255, 255, 0.8)',
            boxShadow: '1px 1px 3px 1px #0000002b',
            ':hover': {
              color: 'rgb(31, 58, 79)',
              background: 'rgba(255, 255, 255, 0.8)',
            },
          }}
        >
          <CameraEnhanceIcon />
        </IconButton>
      </Box>
      <ImageInput
        sx={{
          width: '0px',
          height: '0px',
          visibility: 'hidden',
        }}
        source="avatar_file"
        label="Related pictures"
        inputProps={{ ref: ref }}
        onChange={e => onImageChange(e)}
        multiple={false}
        accept="image/jpg,image/png,image/webp,image/jpeg"
      />
    </>
  );
};

export default AvatarInput;
